/**
 * InHouseStats (IHS) locale bundles only (`InHouseStats.*` keys).
 * Fetched from cloud at build; see `fetch-translations.cjs`.
 */

import ihs_da_DK from './files/ihs/da_DK.json';
import ihs_en_GB from './files/ihs/en_GB.json';
import ihs_en_GB_long from './files/ihs/en_GB_long.json';
import ihs_et_EE from './files/ihs/et_EE.json';
import ihs_fr_FR from './files/ihs/fr_FR.json';
import ihs_ro_RO from './files/ihs/ro_RO.json';

export const ihsLocale = {
  da_DK: ihs_da_DK,
  en_GB: ihs_en_GB,
  en_GB_long: ihs_en_GB_long,
  et_EE: ihs_et_EE,
  fr_FR: ihs_fr_FR,
  ro_RO: ihs_ro_RO,
};

/**
 * English tab labels for the `defSCTab` query parameter (legacy name; same as `UrlParams.DEFAULT_STATS_CONSOLE_TAB`).
 * Used to open the correct IHS main menu tab when the URL passes the English label (e.g. `defSCTab=Stats`).
 * Values must stay aligned with `ihsLocale.en_GB` strings.
 */
export const locale_en_main_menu_names = {
  'InHouseStats.TabStats': ihsLocale.en_GB['InHouseStats.TabStats'],
  'InHouseStats.TabOverview': ihsLocale.en_GB['InHouseStats.TabOverview'],
  'InHouseStats.TabPlayers': ihsLocale.en_GB['InHouseStats.TabPlayers'],
  'InHouseStats.TabLineups': ihsLocale.en_GB['InHouseStats.TabLineups'],
  'InHouseStats.TabH2H': ihsLocale.en_GB['InHouseStats.TabH2H'],
};
